import React, { useEffect, useState } from "react";

/**Import Styles and Assets */
import styles from "./SoundTracks.module.scss";
import back from "./images/back.svg"

import { useListingHeader, useSoundTracksHeader } from "../../schemas/tableHeaderSchema";
import TableLayout from "../../components/TableLayout";
import { useDispatch, useSelector } from "react-redux";
import { fetchSoundTracksThunk } from "../../features/SoundTracksReducer";
import FileReaderModal from "../../components/Modal/FileReaderModal";
import { resetValue } from "../../features/SearchReducer";



export default function SoundTracks() {

    const { data, status } = useSelector(state => state.soundTracks);
    const { search } = useSelector(state => state.search);
    const [list, setList] = useState(data);
    const dispatch = useDispatch();

    const [isListed, setIsListed] = useState(true);
    const [soundTrackList, setSoundTrackList] = useState([])
    const [audioList, setAudioList] = useState(soundTrackList);
    const [file, setFile] = useState({
        path: "",
        type: ""
    });

    const soundTrackHeader = useSoundTracksHeader(setIsListed, setSoundTrackList, setFile);
    const listingHeader = useListingHeader(setSoundTrackList, setFile);

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchSoundTracksThunk());
        }

        return () => dispatch(resetValue())
    }, [])

    useEffect(() => {
        if (!search) return setList(data);


        const array = [
            ...data.map(item => {
                if (item.username.toLowerCase().includes(search.toLowerCase())
                    || item.track_name.toLowerCase().includes(search.toLowerCase())
                    || item.track_artist.toLowerCase().includes(search.toLowerCase())
                ) {
                    return item
                }
            })
        ].filter(Boolean)
        setList(array);

    }, [data, search])

    useEffect(() => {
        if (!search) return setAudioList(soundTrackList);


        const array = [
            ...soundTrackList.map(item => {
                if (item.track_name.toLowerCase().includes(search.toLowerCase())) {
                    return item
                }
            })
        ].filter(Boolean)
        setAudioList(array);

    }, [search, soundTrackList])


    function handleClose() {
        setFile({
            path: "",
            type: "",
        })
    }


    return isListed ?
        <div className={styles.soundTracks} >
            <h1 className={styles.contentTitle}>User Sound Tracks</h1>
            <div className={styles.content}>
                {file.path ? <FileReaderModal {...{ ...file, handleClose }} /> : ""}
                <TableLayout headers={soundTrackHeader} data={list} status={status} />
            </div>
        </div > :
        <div className={styles.soundTracks} >
            <div onClick={() => setIsListed(true)} className={styles.backButton}>
                <img src={back} alt="<" />
                <h1 className={styles.backButton} >Back</h1>
            </div>
            <div className={styles.content}>
                {file.path ? <FileReaderModal {...{ ...file, handleClose }} /> : ""}
                <TableLayout headers={listingHeader} data={audioList} status={"success"} />
            </div>
        </div >





}